import { useEffect, useState } from "react";
import { Bell, Heart, MessageCircle, UserPlus, Crown, Upload, CheckCheck } from "lucide-react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";

const ICONS = { like: Heart, comment: MessageCircle, new_follower: UserPlus, subscription_started: Crown, payment_failed: Crown, upload_approved: Upload, upload_rejected: Upload };

export default function Notifications() {
  const [items, setItems] = useState([]);
  const load = () => api.get("/me/notifications").then(({ data }) => setItems(data.items));
  useEffect(() => { load(); }, []);
  const markRead = async () => { await api.post("/me/notifications/read"); load(); };

  return (
    <div className="max-w-2xl mx-auto px-4 sm:px-6 py-10">
      <div className="flex items-center justify-between mb-6">
        <h1 className="font-head text-4xl font-black tracking-tighter">Notifications</h1>
        <Button variant="ghost" onClick={markRead} className="rounded-full text-sm" data-testid="mark-read"><CheckCheck className="w-4 h-4 mr-2" /> Mark all read</Button>
      </div>
      {items.length === 0 ? (
        <div className="card-surface rounded-2xl p-12 text-center text-muted-foreground"><Bell className="w-8 h-8 mx-auto mb-3 opacity-40" />You're all caught up.</div>
      ) : (
        <div className="space-y-2">
          {items.map((n, i) => {
            const I = ICONS[n.type] || Bell;
            return (
              <div key={i} className={`rounded-2xl p-4 flex items-start gap-3 ${n.read ? "card-surface" : "glass border-neon-pink/30"}`} data-testid={`notif-${i}`}>
                <div className="w-9 h-9 rounded-full bg-neon-purple/20 flex items-center justify-center flex-shrink-0"><I className="w-4 h-4 text-neon-pink" /></div>
                <div className="min-w-0"><p className="text-sm font-semibold">{n.title}</p><p className="text-sm text-muted-foreground">{n.body}</p><p className="text-xs text-muted-foreground/60 mt-1">{new Date(n.created_at).toLocaleString()}</p></div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
